import React from "react";

export const SubscriptionInfo = (props: any) => {
  const {
    session_count,
    price,
    subscription_sequence,
    subscription_booking_id,
  } = props;
  return (
    <div className="col-sm-6 ">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Session Count:</th>
            <td>{session_count}</td>
          </tr>
          <tr>
            <th scope="row">Price:</th>
            <td>{price}</td>
          </tr>
          <tr>
            <th scope="row">Subscription Sequence:</th>
            <td>{subscription_sequence}</td>
          </tr>
          <tr>
            <th scope="row">Subscription Booking Id:</th>
            <td>{subscription_booking_id}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
